import { render, staticRenderFns } from "./postModel.vue?vue&type=template&id=430a452f"
import script from "./postModel.vue?vue&type=script&lang=js"
export * from "./postModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('430a452f')) {
      api.createRecord('430a452f', component.options)
    } else {
      api.reload('430a452f', component.options)
    }
    module.hot.accept("./postModel.vue?vue&type=template&id=430a452f", function () {
      api.rerender('430a452f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/postCustomerManage/postModel.vue"
export default component.exports